import { MdCheckCircle, MdDangerous } from 'react-icons/md';

type Props = {
	message: string;
	severity: 'warning' | 'success' | string;
};

const ConfirmationDialogHeader = (props: Props) => {
	const { message, severity } = props;
	let icon = null;

	switch (severity) {
		case 'warning':
			icon = (
				<MdDangerous
					size={24}
					className="text-error mx-auto"
					data-testid="warning-icon"
				/>
			);
			break;

		case 'success':
			icon = (
				<MdCheckCircle
					size={24}
					className="text-success mx-auto"
					data-testid="success-icon"
				/>
			);
			break;

		default:
			break;
	}

	return (
		<div>
			{icon && icon}
			{message && <h1 className="text-headline-small mt-4">{message}</h1>}
		</div>
	);
};

export default ConfirmationDialogHeader;
